module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gubSo"))).then(() => module.bundle.root('ljYL6'));